var _rect, _path, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShoppingCompleteOrderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 80,
    height: 80,
    rx: 40,
    fill: "#D1FADF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.5003 33.0298C37.5001 33.0199 37.5 33.01 37.5 33V31C37.5 26.8579 40.8579 23.5 45 23.5C49.1421 23.5 52.5 26.8579 52.5 31V33C52.5 33.01 52.4999 33.0199 52.4997 33.0298C55.0742 33.1071 56.6495 33.3848 57.8522 34.3829C59.5186 35.7659 59.9575 38.1068 60.8353 42.7885L62.3353 50.7885C63.5697 57.3719 64.1869 60.6636 62.3875 62.8318C60.588 65 57.239 65 50.5409 65H39.4591C32.761 65 29.4119 65 27.6125 62.8318C25.813 60.6636 26.4302 57.3719 27.6646 50.7885L29.1646 42.7885C30.0424 38.1068 30.4814 35.7659 32.1477 34.3829C33.3504 33.3848 34.9258 33.1071 37.5003 33.0298ZM40.5 31C40.5 28.5147 42.5147 26.5 45 26.5C47.4853 26.5 49.5 28.5147 49.5 31V33C49.5 33 49.5 33 49.5 33C49.3495 33 49.1964 33 49.0409 33H40.9591C40.8035 33 40.6505 33 40.5 33C40.5 33 40.5 33.0001 40.5 33V31ZM51.937 42.8288C52.5839 43.3463 52.6888 44.2902 52.1713 44.9371L44.1713 54.9371C43.9047 55.2703 43.5089 55.4742 43.0829 55.4978C42.6569 55.5214 42.241 55.3624 41.9393 55.0607L37.9393 51.0607C37.3535 50.4749 37.3535 49.5252 37.9393 48.9394C38.5251 48.3536 39.4748 48.3536 40.0606 48.9394L42.8749 51.7537L49.8287 43.063C50.3462 42.4161 51.2901 42.3112 51.937 42.8288Z",
    fill: "#039855"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 80,
    height: 80,
    rx: 40,
    stroke: "#ECFDF3",
    strokeWidth: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingCompleteOrderIcon);
export default __webpack_public_path__ + "static/media/shopping-complete-order-icon.97438d72a5fee75e0b11e16705921aa8.svg";
export { ForwardRef as ReactComponent };